import { render, staticRenderFns } from "./SelfVerify.vue?vue&type=template&id=3b74ddb7&scoped=true"
import script from "./SelfVerify.vue?vue&type=script&lang=js"
export * from "./SelfVerify.vue?vue&type=script&lang=js"
import style0 from "./SelfVerify.vue?vue&type=style&index=0&id=3b74ddb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b74ddb7",
  null
  
)

export default component.exports